(function(angular){
	'use strict';
	
	var reitElementGridObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			reitElements: '<',
			numCols: '@?',
			initialShow: '<?'
		},
		controller: [
			'$scope',
			'mixpanelFactory',
			ReitElementGridFunction],
		controllerAs: 'reitElementGrid'
	};
	
	angular
		.module('reitElementListingModule')
		.component('reitElementGrid', reitElementGridObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/reit-element-container/reit-element-grid.html';
	}

	function ReitElementGridFunction(
		$scope,
		mixpanelFactory
		){
		var reitElementGrid = this;
		reitElementGrid.pageSize = 12;
		reitElementGrid.currentPage = 0;
		var itemClasses;

		reitElementGrid.getItemClasses = function(index) {
			if(reitElementGrid.numCols === '4') {
				itemClasses = 'display-block col-4-md col-3-lg';
			} else {
				itemClasses = 'display-block col-4-md';
			}

			if(index >= 1) {
				itemClasses += ' mt-100-smo';
			}
			
			if(index >= 3) {
			 	itemClasses += ' mt-150-md';
			}

			if(index === 3 && reitElementGrid.numCols === '4') {
				itemClasses += ' mt-0-lg';
			}
			return itemClasses;
		};

		$scope.$on('pagination:update', function(evt, data) {
			reitElementGrid.currentPage = data.currentPage;
			$scope.$broadcast('runLazyLoad');
		});
	}
})(window.angular);